import {GetComplianceFormResponse} from "kbd/protocol/response/GetComplianceFormResponse";
import {XhrManager} from "kbd/core/engine/XhrManager";
import Platform from "platform/Platform";

export class BIUtil {

    private constructor() {
    }

    public static identify() {
        XhrManager.sendToForm({}, "GetComplianceForm").then((response: GetComplianceFormResponse) => {
            if (response?.UserId) {
                Platform.bi().identify(response.UserId);
            }
        });
    }
}
